import {
  GET_FOOD_SHIFT_REPORT_LIST,
  GET_FOOD_SHIFT_REPORT_LIST_SUCCESS,
  GET_FOOD_SHIFT_REPORT_LIST_FAILURE,
  SEARCH_FOOD_SHIFT_REPORT,
  SEARCH_FOOD_SHIFT_REPORT_SUCCESS,
  SEARCH_FOOD_SHIFT_REPORT_FAILURE,
} from "./actionType";

const initialState = {
  foodShiftReportList: [],
  foodShiftReportListLoading: false,
  foodShiftReportListError: null,

  searchFoodShiftReport: [],
  searchFoodShiftReportLoading: false,
  searchFoodShiftReportError: null,
};

const ShiftReport = (state = initialState, action) => {
  switch (action.type) {
    case GET_FOOD_SHIFT_REPORT_LIST:
      return {
        ...state,
        foodShiftReportListLoading: true,
        foodShiftReportListError: null,
      };
    case GET_FOOD_SHIFT_REPORT_LIST_SUCCESS:
      return {
        ...state,
        foodShiftReportList: action.payload,
        foodShiftReportListLoading: false,
      };
    case GET_FOOD_SHIFT_REPORT_LIST_FAILURE:
      return {
        ...state,
        foodShiftReportListLoading: false,
        foodShiftReportListError: action.payload,
      };

    case SEARCH_FOOD_SHIFT_REPORT:
      return {
        ...state,
        searchFoodShiftReportLoading: true,
        searchFoodShiftReportError: null,
      };
    case SEARCH_FOOD_SHIFT_REPORT_SUCCESS:
      return {
        ...state,
        searchFoodShiftReport: action.payload,
        searchFoodShiftReportLoading: false,
      };
    case SEARCH_FOOD_SHIFT_REPORT_FAILURE:
      return {
        ...state,
        searchFoodShiftReportLoading: false,
        searchFoodShiftReportError: action.payload,
      };
    default:
      return state;
  }
};

export default ShiftReport;
